import axios from './axios';


export default class HomeService{

    static async list(query={}){
        return await axios.get(`/home/list`,{
            params:query
        });
    };
} 